module.exports = __webpack_public_path__ + "lp/img/mic_icn-off@2x.90a2c82f.png";